<template>
    <div>
        <n-bread
                v-bind:content="{bread_list, bread_active}"
        ></n-bread>
        <div class="row">
            <div class="col-md-8">
                <div class="card abtg__default-card abtg__default-card-border">

                    <div class="card-body ">

                        <iframe width="100%" height="550" :src="singleVideo"
                                frameborder="0"
                                allowfullscreen=""></iframe>


                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card abtg__default-card abtg__default-card-border">
                    <div class="card-head">
                        <header>Archivio Video</header>
                    </div>
                    <div class="card-body ">


                        <div v-for="v in video" v-if="v.snippet.thumbnails !== undefined">
                            <div class="row">
                                <div class="col-lg-4">

                                    <a @click="changeBigVideo({url:v.snippet.resourceId.videoId})"><img
                                            :src="v.snippet.thumbnails.high.url" class="img-fluid"/></a>

                                </div>
                                <div class="col-lg-8">
                                    <h5 style="line-height:20px;"><a
                                            @click="changeBigVideo({url:v.snippet.resourceId.videoId})">{{v.snippet.title}}</a>
                                    </h5>

                                </div>
                            </div>
                            <hr>
                        </div>
                        <a @click="getData(myPrev, 'prev')" v-if="myPrev != undefined"><i class="fas fa-angle-left"></i>
                            Indietro</a>
                        &nbsp;&nbsp;<a @click="getData(myNext, 'next')" v-if="myNext != undefined">Avanti <i
                            class="fas fa-angle-right"></i></a>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>
    import NBread from '@/partials/bread';
    import {mapActions, mapState, mapMutations} from 'vuex';

    export default {
        components: {
            NBread,
        },
        computed: {
            ...mapState('n_pills', ['bread_active', 'bread_list', 'pages', 'singleVideo', 'video']),
            myPrev() {
                return this.pages[this.pages.length - 3];
            },

            myNext() {
                return this.pages[this.pages.length - 1];
            }
        },
        created() {
            this.SET_DATA({name: 'bread_active', data: {label: 'Le pillole immobiliari di Alfio Bardolla'}});
            this.getData({pagination: 'next', button: undefined});
        },

        methods: {
            ...mapActions('n_pills', ['getData', 'changeBigVideo']),
            ...mapMutations('n_pills', ['SET_DATA']),
        }
    }
</script>